import request from '@utils/request'

export function fetchClientList(params) {
  return request({
    url: '/admin/oauth2/client',
    method: 'get',
    params,
  })
}

export function fetchClient(client_seq) {
  return request.get(`/admin/oauth2/client/${client_seq}`)
}

export function createClient(data) {
  return request.post('/admin/oauth2/client', data)
}

export function updateClient({ seq, ...data }) {
  return request.put(`/admin/oauth2/client/${seq}`, data)
}

export function deleteClient(client_seq) {
  return request.delete(`/admin/oauth2/client/${client_seq}`)
}

export function fetchClientGrants(client_seq) {
  return request({
    url: `/admin/oauth2/client/${client_seq || 0}/grant`,
  })
}

export function fetchClientGrant(client_seq, seq) {
  return request({
    url: `/admin/oauth2/client/${client_seq || 0}/grant/${seq || 0}`,
    method: 'get',
  })
}

export function createClientGrant({ client_seq, ...data }) {
  return request.post(`/admin/oauth2/client/${client_seq || 0}/grant/`, data)
}

export function updateClientGrant({ client_seq, seq, ...data }) {
  return request.put(
    `/admin/oauth2/client/${client_seq || 0}/grant/${seq}`,
    data
  )
}

export function deleteClientGrant(client_seq, seq) {
  return request.delete(`/admin/oauth2/client/${client_seq || 0}/grant/${seq}`)
}
